module.exports = __webpack_public_path__ + "img/top.97560ece.svg";